import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SELECT_SEDE(state, item) {
            state.value = item;
        },
        SET_SEDES(state, items = []) {
            state.items = [...state.items, ...items];
        },
        ADD_SEDE(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_SEDE(state, Id) {
            const ind = state.items.findIndex(sede => sede.id === Id);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_SEDE(state, { Id, sede }) {
            const ind = state.items.findIndex(sede => sede.id === Id);

            if (ind !== -1) {
                Vue.set(state.items, ind, sede);
            }
        }
    },

    actions: {
        selectSede({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return exitsItem ? (commit('SELECT_SEDE', data), true) : false;
        },

        setSedes({ state, commit }, data = []) {
            data.forEach(sede => {
                if (!state.items.find(item => item.id == sede.id)) {
                    commit('ADD_SEDE', sede);
                }
            });
            return true;
        },

        addSede({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === data.id);
            return !exitsItem ? (commit('ADD_SEDE', data), true) : false;
        },

        deleteSede({ state, commit }, id) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item.id === id);
            return exitsItem ? (commit('DELETE_SEDE', id), true) : false;
        },

        // editSede({ commit }, data) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             commit('EDIT_SEDE', data);
        //             resolve();
        //         }, 250);
        //     });
        // }
    }
};
